module.exports = __webpack_public_path__ + "static/img/cer_yes_banner.f043e028.png";